module.exports = __webpack_public_path__ + "static/media/universal-access.3800f608.svg";